export default __webpack_public_path__ + "static/media/home_smartphonecash_desktop-01.a9cce807.svg";